import FetchHelper from '../helpers/fetch_helper';
import moment from 'moment';
import Actions from '../actions/actions';
import AuthHelper from '../helpers/auth_helper';

const WelcomeCallDispatcher = {
  clearWelcomeCall() {
    this.setStoreVal('wcAuth', null);
    sessionStorage.removeItem('WC_JWT_Token');
  },

  welcomeCallAuthCheck() {
    const jwtToken = sessionStorage.getItem('WC_JWT_Token');
    if (jwtToken) {
      this.setStoreVal('wcAuth', jwtToken);
    }
  },

  getHomeOwnerTypeFromJWT() {
    if (!sessionStorage.getItem('WC_JWT_Token')) {
      return 'NO_JWT';
    }
    return JSON.parse(atob(sessionStorage?.getItem('WC_JWT_Token')?.split('.')?.[1]))?.atype === 'HP'
      ? 'Primary'
      : 'Secondary';
  },

  async fetchWelcomeCallAuth(data) {
    try {
      const response = (
        await FetchHelper.fetchJson(`welcome-calls/${data.guid}/login`, {
          method: 'post',
          version: '/v3',
          body: JSON.stringify({
            ssn: data.ssn,
            dob: moment(data.dob).format('YYYY-MM-DD'),
            expired: data.expired,
          }),
        })
      ).access_token;
      this.setStoreVal('wcAuth', response);
      sessionStorage.setItem('WC_JWT_Token', response);
    } catch (error) {
      if (error.code === 410) {
        Actions.setErrorMessages(error.messages);
        return;
      }
      Actions.setErrorMessages(['Incorrect information provided. Please verify and resubmit.']);
    }
  },

  async fetchWCQuestions(data) {
    let jwt = sessionStorage.getItem('WC_JWT_Token');
    try {
      const results = (
        await FetchHelper.fetchJson(`welcome-calls/${data}`, {
          method: 'get',
          version: '/v3',
          headers: {
            authorization: `Bearer ${jwt ? jwt : AuthHelper.getSessionToken()}`,
          },
        })
      ).results?.[0];

      this.setStoreVal('welcomeCallResponses', results);
    } catch (e) {
      Actions.setErrorMessages([
        'This link is either expired or the associated financing agreement has been cancelled.',
      ]);
      setTimeout(() => {
        sessionStorage.removeItem('WC_JWT_Token');
        window.location.reload();
      }, 5 * 1000);
    }
  },

  async fetchWelcomeCallByCustomerId(data) {
    try {
      let jwt = sessionStorage.getItem('WC_JWT_Token');
      const response = (
        await FetchHelper.fetchJson(`welcome-calls?customerIds=${data}`, {
          method: 'get',
          version: '/v3',
          headers: {
            authorization: `Bearer ${jwt ? jwt : AuthHelper.getSessionToken()}`,
          },
        })
      )?.results?.[0];
      this.setStoreVal('welcomeCallResponses', response);
    } catch (error) {
      Actions.setErrorMessages(['Not Authorized']);
    }
  },

  async putWelcomeCallQuestions(data) {
    try {
      let token = `${data.token}`;
      delete data.token;

      const response = (
        await FetchHelper.fetchJson(`welcome-calls/${token}`, {
          method: 'PUT',
          version: '/v3',
          body: JSON.stringify(data),
          headers: {
            authorization: `Bearer ${
              sessionStorage.getItem('WC_JWT_Token')
                ? sessionStorage.getItem('WC_JWT_Token')
                : AuthHelper.getSessionToken()
            }`,
          },
        })
      )?.results?.[0];
      this.setStoreVal('welcomeCallResponses', response);
      if (AuthHelper.isCPFUser(this.getStoreVal('user'))) {
        Actions.setMessages(['Responses saved']);
      }
      return response;
    } catch (error) {
      Actions.setView({ page: 'welcomeCallErrorPage' });
      const errors = { ...error };
      Actions.setErrorMessages(errors.messages);
    }
  },

  async goToWelcomeCall({ id, inNewTab }) {
    if (inNewTab) {
      window.open(`${window.location.protocol}//${window.location.host}/welcome-calls/${id}`, '_blank').focus();
    } else {
      this.dispatch({ type: 'setRoute', data: `/welcome-calls/${id}` });
    }
  },
};

export default WelcomeCallDispatcher;
